import { render } from "./QuartersList.vue?vue&type=template&id=9dde2fee&scoped=true"
import script from "./QuartersList.vue?vue&type=script&lang=js"
export * from "./QuartersList.vue?vue&type=script&lang=js"

import "./QuartersList.vue?vue&type=style&index=0&id=9dde2fee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dde2fee"]])

export default __exports__